/* 🤖 this file was generated by svg-to-ts */
export const nsVisibility: {
  name: 'visibility';
  data: string;
} = {
  name: 'visibility',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M11 5.5a9.77 9.77 0 0 1 8.82 5.5A9.77 9.77 0 0 1 11 16.5 9.77 9.77 0 0 1 2.18 11 9.77 9.77 0 0 1 11 5.5Zm0-2C6 3.5 1.73 6.61 0 11c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5Zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5Zm0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5Z" clip-rule="evenodd"/></svg>`
};
